import { render } from "./advisorInsightSkeleton.vue?vue&type=template&id=40bbc35e&ts=true"
import script from "./advisorInsightSkeleton.vue?vue&type=script&lang=ts"
export * from "./advisorInsightSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__